'use client';

import { Box } from '@mui/system';
import { useEffect, useState } from 'react';

/**
 * Sendpulse snippet
 *
 * @returns {React.JSX.Element} The Sendpulse snippet.
 */
export const Sendpulse = ({ id }: { id?: string }) => {
  const sendpulseId = process.env.NEXT_PUBLIC_SENDPULSE_ID;
  const [started, setStarted] = useState(false);
  const [targetHeight, setTargetHeight] = useState(0);
  /* c8 ignore start */
  if (!sendpulseId) {
    console.warn('Missing sendpulseId ID, skipping banner');
    return <></>;
  }
  function handleWindowSizeChange() {
    const element = document.getElementsByClassName('sp-inline-popup')[0];
    if (element) {
      setTargetHeight(element.clientHeight);
    }
  }
  useEffect(() => {
    setStarted(true);
    window.addEventListener('resize', handleWindowSizeChange);
    const interval = setInterval(async () => {
      const a = document.getElementsByClassName('sp-inline-popup');
      const spStyle = document.createElement('style');
      spStyle.innerHTML = `
        .sp-popup-wrapper {
          width:100% !important;
        }
      `;
      if (a.length > 0) {
        a[0]?.shadowRoot?.appendChild(spStyle);
        setTargetHeight(a[0]?.clientHeight || 0);
        clearInterval(interval);
      }
    }, 500);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);
  /* c8 ignore end */
  return (
    <Box
      sx={{ height: `${targetHeight}px`, opacity: targetHeight > 0 ? '100' : '0', transition: 'all 0.3s ease-in-out' }}
    >
      <div id={`send_pulse${id ? `_${id}` : ''}`} />
      {started && (
        <>
          <script async src="https://static.sppopups.com/assets/loader.js" data-chats-widget-id={sendpulseId} />
        </>
      )}
    </Box>
  );
};

export default Sendpulse;
